'use client'

import React, { useContext } from 'react'
import { SectionThemeContext } from '../../../contexts/SectionTheme.context'
import { Container } from '../../atoms/GridSystem'
import BentoBoxCaseElement from '../../molecules/BentoBoxCaseElement/BentoBoxCaseElement.component'
import { NormalizedBentoBoxCaseProps } from '../../../models/organisms/BentoBoxCase'
import * as S from './BentoBoxCase.styles'

const BentoBoxCase = ({
  sectionId,
  items,
  withBackground,
  ...props
}: NormalizedBentoBoxCaseProps) => {
  const { selectedColorScheme } = useContext(SectionThemeContext)

  return (
    <S.BentoBoxCase
      colorScheme={selectedColorScheme}
      withBackground={withBackground}
      id={sectionId}
    >
      <Container>
        <S.BentoBoxCaseGrid>
          {items.map((item, i) => (
            <S.BentoBoxCaseCardWrapper key={`BentoBoxCaseCard-${i}-${item?.id}`}>
              <BentoBoxCaseElement {...item} />
            </S.BentoBoxCaseCardWrapper>
          ))}
        </S.BentoBoxCaseGrid>
      </Container>
    </S.BentoBoxCase>
  )
}

export default BentoBoxCase

